import React from 'react';
import { motion } from 'framer-motion';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PropTypes from 'prop-types';

const CustomFuzzyToast = ({ message }) => {
  return (
    <motion.div
      initial={{ opacity: 0.3 }}
      animate={{
        opacity: [0.3, 1, 0.3],
        transition: {
          repeat: Infinity,
          duration: 1.5,
        },
      }}
      className="bg-blue-100 border-l-4 border-blue-600 text-blue-900 p-4 rounded shadow-md"
      style={{
        width: '320px',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        fontWeight: 500,
        color: '#000000',
        // boxShadow: '0 0 15px rgba(0, 123, 255, 0.6)',
      }}
    >
      <WarningAmberIcon style={{ color: '#0056D2', fontSize: 28 }} />
      <div style={{ fontSize: '0.95rem' }}>{message}</div>
    </motion.div>
  );
};

CustomFuzzyToast.propTypes = {
  message: PropTypes.string.isRequired,
};

export default CustomFuzzyToast;
